import React, { useState, useEffect } from "react";
import { AuthApi, ApiClient } from "./tradingApiSdk/src";
import { useNavigate } from "react-router-dom";

// CloudScape components
import {
  Box,
  Button,
  Container,
  Form,
  FormField,
  Grid,
  Header,
  Icon,
  Input,
  Link,
  SpaceBetween,
  TextContent,  // Changed from Text to TextContent
  Alert
} from "@cloudscape-design/components";

function detectApiBaseUrl() {
  const hostname = window.location.hostname;
  if (hostname.includes("beta")) {
    return "https://beta-api.edge.a1ultra.com";
  } else if (hostname.includes("127.0.0.1")) {
    return "http://127.0.0.1:5000";
  } else {
    return "https://bpgsxuj2jcm33m5w3p55sbfrtm0sitcn.lambda-url.ap-south-1.on.aws";
  }
}

export default function LoginPage({ onLoginSuccess, colorMode = 'light' }) {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function checkStatus() {
      try {
        const client = new ApiClient();
        client.basePath = detectApiBaseUrl();
        client.enableCookies = true;
        client.fetchOptions = { credentials: "include", cache: "no-cache" };

        const res = await fetch(`${client.basePath}/auth/status`, {
          credentials: "include",
          cache: "no-cache",
        });
        const data = await res.json();

        if (data.logged_in) {
          onLoginSuccess();
          navigate("/", { replace: true });
        }
      } catch (err) {
        console.error("Status check error:", err);
      }
    }
    checkStatus();
  }, [navigate, onLoginSuccess]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setErrorMsg("");
    setLoading(true);

    try {
      const client = new ApiClient();
      client.basePath = detectApiBaseUrl();
      client.enableCookies = true;
      client.fetchOptions = { credentials: "include" };

      const authApi = new AuthApi(client);
      await authApi.postLoginResource({ username, password });

      onLoginSuccess();
      navigate("/", { replace: true });
    } catch (err) {
      console.error("Login error:", err);
      setErrorMsg("Login failed. Please check your credentials and try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      padding="xxl"
      style={{
        backgroundColor: colorMode === 'dark' ? '#0f1b2a' : '#f8f8f8',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'        
      }}
    >
      <Grid
        gridDefinition={[
          { colspan: { default: 12, xs: 12, s: 10, m: 8, l: 6, xl: 4 } }
        ]}
        style={{
           width: '100%',
          }}
      >
        <div>
          <Box
            padding="xxl"
            textAlign="center"
            margin={{ bottom: "l" }}
          >
            <SpaceBetween size="s">
              <Icon
                name="calendar"
                size="large"
                variant="inverted"
                style={{
                  backgroundColor: '#0972d3',
                  padding: '0.8rem',
                  borderRadius: '50%',
                  fontSize: '2rem',
                  display: 'inline-block'
                }}
              />
              <TextContent>
                <h1>A1Ultra Trading Edge</h1>
                <p>Sign in to access your account</p>
              </TextContent>
            </SpaceBetween>
          </Box>

          <Container>
            <form onSubmit={handleSubmit}>
              <SpaceBetween size="l">
                {errorMsg && (
                  <Alert type="error" dismissible onDismiss={() => setErrorMsg("")}>
                    {errorMsg}
                  </Alert>
                )}

                <FormField
                  label="Username"
                >
                  <Input
                    type="text"
                    value={username}
                    onChange={({ detail }) => setUsername(detail.value)}
                    placeholder="Enter your registered username"
                    autoFocus
                  />
                </FormField>

                <FormField
                  label="Password"
                >
                  <Input
                    type="password"
                    value={password}
                    onChange={({ detail }) => setPassword(detail.value)}
                    placeholder="Enter your password"
                  />
                </FormField>

      

                <Button
                  variant="primary"
                  formAction="submit"
                  fullWidth
                  loading={loading}
                  disabled={!username || !password || loading}
                >
                  Sign In
                </Button>

              {/*
                <Box textAlign="center" margin={{ top: "m" }}>
                  <TextContent>
                    <small>
                      By signing in, you agree to the&nbsp;
                      <Link href="#terms-of-service">Terms of Service</Link>
                      &nbsp;and&nbsp;
                      <Link href="#privacy-policy">Privacy Policy</Link>
                    </small>
                  </TextContent>
                </Box>
              */}
              </SpaceBetween>
            </form>
          </Container>


        </div>
      </Grid>
    </Box>
  );
}